import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TechLayout from '../../components/tech/TechLayout';
import { getWorkOrder, techUpdateWorkOrder } from '../../api/client';

export default function TechJobNotes() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [diagnosis, setDiagnosis] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await getWorkOrder(id);
        setDiagnosis(res.data.diagnosis || '');
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const handleSave = async () => {
    try {
      setSaving(true);
      await techUpdateWorkOrder(id, { diagnosis });
      setMessage('Saved successfully');
      setTimeout(() => setMessage(''), 2500);
    } catch (err) {
      console.error(err);
      const detail = err.response?.data?.detail;
      setMessage(typeof detail === 'string' ? detail : 'Save failed, please try again');
      setTimeout(() => setMessage(''), 3000);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <TechLayout title="Diagnosis / Repair Action">
        <div style={{ textAlign: 'center', padding: 40 }}>Loading...</div>
      </TechLayout>
    );
  }

  return (
    <TechLayout title="Diagnosis / Repair Action">
      <button
        onClick={() => navigate(`/tech/jobs/${id}`)}
        style={{ marginBottom: 14, border: 'none', background: '#F3F4F6', padding: '8px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
      >
        ← Back
      </button>

      <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, padding: 16, marginBottom: 14 }}>
        <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 14, color: '#374151' }}>
          Diagnosis / Repair Action
        </div>
        <textarea
          value={diagnosis}
          onChange={(e) => setDiagnosis(e.target.value)}
          style={{ width: '100%', minHeight: 200, borderRadius: 8, border: '1px solid #D1D5DB', padding: 10, fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }}
          placeholder="Describe the diagnosis and repair action taken..."
        />
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        style={{ width: '100%', background: '#2563EB', color: '#fff', border: 'none', padding: '14px', borderRadius: 10, fontWeight: 700, fontSize: 15, cursor: 'pointer', marginTop: 4 }}
      >
        {saving ? 'Saving...' : 'Save'}
      </button>

      {message && (
        <div style={{
          marginTop: 10, textAlign: 'center', fontWeight: 600, fontSize: 14,
          color: message === 'Saved successfully' ? '#059669' : '#DC2626',
        }}>
          {message}
        </div>
      )}
    </TechLayout>
  );
}
